/**
 * 绑卡流程共4个接口
 * - 验证卡号 /customerV2/checkCardNo
 * - 验证用户信息 /customerV2/checkUserInfo
 * - 验证用户信息及验证码 /customerV2/v2/checkUserPhoneCode
 * - 查询 3DS 验证结果 /customerV2/get3DSVerificationResults
 *
 * - 获取银联卡绑卡需要的bindingKey /customerV2/getCupCardBindingData
 * - 银联绑卡 /customerV2/cupCardBinding
 */
import fetch from '@/utils/fetch/index'

export interface CheckCardNoParams {
  /** 银行编码，02：大丰、03：澳门国际、04：银联无感、05：BNU、06：VM、07:银联二维码、08、澳门发展银行 */
  bankNo: string
  /** 绑卡会话ID（银联无感、中银VM） */
  bindingSessionId?: string
  /** 卡号、账户号（非明文） */
  cardNo: string
}

export interface CheckUserInfoParams extends CheckCardNoParams {
  /** 生日，绑卡为大西洋账户时必输，格式 yyyyMMDD */
  birthday?: string
  /** 银行卡类型，01：信用卡、02：借记卡、03：账户 */
  cardType: string
  /** 银行卡安全码（非明文） */
  cvn2?: string
  /**
   * 有效期，月/年，格式 MM/yy （非明文）
   * @example 07/25
   */
  expiryDate?: string
  /** 证件号码 （非明文） */
  idNo: string
  /** 证件类型 */
  idType: string
  /** 证件姓名（非明文） */
  name?: string
  /** 手机号（非明文） */
  phone: string
  /** 手机区号，0086、00853、00852 */
  phoneArea?: string
}

export interface CheckUserInfoParamsAndCode extends CheckUserInfoParams {
  /** 验证码（非明文） */
  code: string
}

export interface Get3DSVerificationResultsParams {
  /** 绑卡会话ID */
  bindSessionId: string
  /** 3DS 验证订单ID */
  thirdDSOrderId: string
}

/**
 * 验证卡号
 * @param params
 * @returns
 */
export function checkCardNo(params: CheckCardNoParams) {
  return fetch('/customerV2/checkCardNo', {
    params,
  })
}

/**
 * 验证用户信息
 * @param params
 * @returns
 */
export function checkUserInfo(params: CheckUserInfoParams) {
  return fetch('/customerV2/checkUserInfo', {
    params,
  })
}

/**
 * 验证用户信息及验证码
 * @param params
 * @returns
 */
export function checkUserPhoneCode(params: CheckUserInfoParamsAndCode) {
  return fetch('/customerV2/v2/checkUserPhoneCode', {
    params,
  })
}

/**
 * 查询 3DS 验证结果
 * @param params
 * @returns
 */
export function get3DSVerificationResults(params: Get3DSVerificationResultsParams) {
  return fetch('/customerV2/get3DSVerificationResults', {
    params,
  })
}

/**
 * 获取银联卡绑卡需要的bindingKey
 * @param params
 * @returns
 */
export function getUnionBindingKey(params) {
  return fetch('/customerV2/getCupCardBindingData', {
    params,
  })
}

/**
 * 银联绑卡
 * @param params
 * @returns
 */
export function bindUnionCard(params) {
  return fetch('/customerV2/cupCardBinding', {
    params,
  })
}

/**
 * 中银VM渠道 3ds获取付款方认证
 * @param params
 */
export function queryBindCardAuthenticatePayer(params) {
  return fetch('/customerV2/authenticatePayer', {
    params,
  })
}

/**
 * 中银VM渠道 支付3ds认证 验证付款人
 * @param params
 */
export function queryPayAuthenticatePayer(params) {
  return fetch('/clientTrade/authenticatePayer', {
    params,
  })
}
